//文件相关的请求
import { request } from "@/utils";

export function uploadFileAPI(file) {
  return request({
    url: '/file-handle/upload',
    method: 'POST',
    data: file
  })
}

export function uploadFileByBatchAPI(files) {
  return request({
    url: '/file-handle/upload-by-batch',
    method: 'POST',
    data: files
  })
}

export function listFileAPI() {
  return request({
    url: '/file-handle/list',
    method: 'GET',
  })
}

export function downloadFileAPI(fileId) {
  return request({
    url: `/file-handle/download?fileId=${fileId}`,
    method: 'POST',
    responseType: 'blob', // 重要：指定响应类型为blob
  })
}

// 新增：处理文件下载并触发浏览器下载对话框
export function downloadFileWithSaveDialog(fileId, customFileName = null) {

  return new Promise((resolve, reject) => {
    request({
      url: `/file-handle/download?fileId=${fileId}`,
      method: 'POST',
      responseType: 'blob',
    })
      .then(response => {
        try {
          // 确保response是blob格式
          const responseData = response.data || response;
          const blob = new Blob([responseData], {
            type: responseData.type || 'application/octet-stream'
          });

          // 创建下载链接
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // 设置文件名
          let filename = customFileName;
          if (!filename) {
            // 尝试从响应头获取文件名
            const headers = response.headers || {};
            const contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];

            if (contentDisposition) {
              // 处理中文文件名编码
              const filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
              if (filenameMatch) {
                filename = decodeURIComponent(filenameMatch[1]);
              } else {
                const normalMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (normalMatch && normalMatch[1]) {
                  filename = normalMatch[1].replace(/['"]/g, '');
                  // 尝试解码UTF-8编码的文件名
                  try {
                    filename = decodeURIComponent(filename);
                  } catch (e) {
                    // 解码失败，使用原文件名
                    console.warn('Failed to decode filename:', e);
                  }
                }
              }
            }
          }

          // 如果还是没有文件名，使用默认名称
          if (!filename) {
            const now = new Date();
            const year = now.getFullYear().toString().slice(-2); // 取年份后两位
            const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份补零
            const day = now.getDate().toString().padStart(2, '0'); // 日期补零
            const hour = now.getHours().toString().padStart(2, '0'); // 小时补零
            const minute = now.getMinutes().toString().padStart(2, '0'); // 分钟补零
            const second = now.getSeconds().toString().padStart(2, '0'); // 秒数补零
            // const millisecond = now.getMilliseconds().toString().padStart(3, '0'); // 毫秒补零
            const timeStr = `${year}${month}${day}${hour}${minute}${second}`;
            filename = `download_${fileId}_${timeStr}`;
          }

          link.download = filename;

          // 设置链接样式，确保不影响页面布局
          link.style.display = 'none';

          // 触发下载
          document.body.appendChild(link);
          link.click();

          // 延迟清理，确保下载开始
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);

          resolve({
            success: true,
            filename: filename,
            blob: blob
          });
        } catch (error) {
          console.error('Download process failed:', error);
          reject(error);
        }
      })
      .catch(error => {
        console.error('Download request failed:', error);
        reject(error);
      });
  });
}

export function getFileIdByFileNameAPI(fileName) {
  return request({
    url: `/file-handle/get-fileId-by-filename?id=${fileName}`,
    method: 'POST',
  })
}

export function getFileUrlByFileIdAPI(id) {
  return request({
    url: `/file-handle/get-fileUrl-by-fileId?id=${id}`,
    method: 'POST',
  })
}

export function deleteFileUrlByFileIdAPI(id) {
  return request({
    url: `/file-handle/delete-file?id=${id}`,
    method: 'POST',
  })
}

// 高级文件下载函数，支持进度回调和自定义配置
export function downloadFileAdvanced(fileId, options = {}) {
  const {
    filename = null,
    showProgress = false,
    onProgress = null,
    onSuccess = null,
    onError = null
  } = options;

  return new Promise((resolve, reject) => {
    const config = {
      url: `/file-handle/download?fileId=${fileId}`,
      method: 'POST',
      responseType: 'blob',
    };

    // 如果需要显示进度
    if (showProgress && onProgress) {
      config.onDownloadProgress = (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      };
    }

    request(config)
      .then(response => {
        try {
          // 确保response是blob格式
          const responseData = response.data || response;
          const blob = new Blob([responseData], {
            type: responseData.type || 'application/octet-stream'
          });

          // 创建下载链接
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // 设置文件名
          let finalFilename = filename;
          if (!finalFilename) {
            // 尝试从响应头获取文件名
            const headers = response.headers || {};
            const contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];

            if (contentDisposition) {
              // 处理中文文件名编码
              const filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
              if (filenameMatch) {
                finalFilename = decodeURIComponent(filenameMatch[1]);
              } else {
                const normalMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (normalMatch && normalMatch[1]) {
                  finalFilename = normalMatch[1].replace(/['"]/g, '');
                  // 尝试解码UTF-8编码的文件名
                  try {
                    finalFilename = decodeURIComponent(finalFilename);
                  } catch (e) {
                    // 解码失败，使用原文件名
                    console.warn('Failed to decode filename:', e);
                  }
                }
              }
            }
          }

          // 如果还是没有文件名，使用默认名称
          if (!finalFilename) {
            const now = new Date();
            const year = now.getFullYear().toString().slice(-2); // 取年份后两位
            const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份补零
            const day = now.getDate().toString().padStart(2, '0'); // 日期补零
            const hour = now.getHours().toString().padStart(2, '0'); // 小时补零
            const minute = now.getMinutes().toString().padStart(2, '0'); // 分钟补零
            const second = now.getSeconds().toString().padStart(2, '0'); // 秒数补零
            const millisecond = now.getMilliseconds().toString().padStart(3, '0'); // 毫秒补零
            const timeStr = `${year}${month}${day}${hour}${minute}${second}${millisecond}`;
            finalFilename = `download_${fileId}_${timeStr}`;
          }

          link.download = finalFilename;

          // 设置链接样式，确保不影响页面布局
          link.style.display = 'none';

          // 触发下载
          document.body.appendChild(link);
          link.click();

          // 延迟清理，确保下载开始
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);

          // 成功回调
          if (onSuccess) {
            onSuccess(finalFilename);
          }

          resolve({
            success: true,
            filename: finalFilename,
            blob: blob
          });
        } catch (error) {
          console.error('Advanced download process failed:', error);
          if (onError) {
            onError(error);
          }
          reject(error);
        }
      })
      .catch(error => {
        console.error('Advanced download request failed:', error);
        if (onError) {
          onError(error);
        }
        reject(error);
      });
  });
}

// 批量下载文件（压缩包形式）
export function downloadBatchFilesAPI(fileIds) {
  return request({
    url: '/file-handle/download-batch',
    method: 'POST',
    data: fileIds,
    responseType: 'blob',
  })
}

// 批量下载文件处理函数
export function downloadBatchFiles(fileIds, zipFileName = null) {
  return new Promise((resolve, reject) => {
    if (!fileIds || fileIds.length === 0) {
      reject(new Error('文件ID列表不能为空'));
      return;
    }

    downloadBatchFilesAPI(fileIds)
      .then(response => {
        try {
          // 确保response是blob格式
          const responseData = response.data || response;
          const blob = new Blob([responseData], { type: 'application/zip' });

          // 创建下载链接
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // 设置文件名
          const filename = zipFileName || `batch_download_${new Date().getTime()}.zip`;
          link.download = filename;

          // 设置链接样式，确保不影响页面布局
          link.style.display = 'none';

          // 触发下载
          document.body.appendChild(link);
          link.click();

          // 延迟清理，确保下载开始
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);

          resolve({
            success: true,
            filename: filename,
            count: fileIds.length
          });
        } catch (error) {
          console.error('Batch download process failed:', error);
          reject(error);
        }
      })
      .catch(error => {
        console.error('Batch download request failed:', error);
        reject(error);
      });
  });
}